import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const PaymentTypeAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.paymentTypeAccess
        ? setValues((j) => ({
            ...j,
            paymentType: {
              create: true,
              edit: true,
              delete: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            paymentType: {
              create: false,
              edit: false,
              delete: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.paymentTypeAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      paymentType: { ...j.paymentType, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.paymentTypeAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.paymentType?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.paymentType?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.paymentType?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default PaymentTypeAccess;
